import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

const GemxInfo = ({ isOpen, onClose }) => {
  const [visible, setVisible] = useState(false);
  const primaryColor = '#000000'; // New purple color

  const navigate = useNavigate()

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => setVisible(true), 10); // trigger animation
    } else {
      setVisible(false);
      // Add delay before removing from DOM
      const timer = setTimeout(() => {
        // This just ensures the animation completes before unmounting
      }, 400);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
  
    if (isOpen) {
      setTimeout(() => setVisible(true), 10);
      window.addEventListener('keydown', handleKeyDown);
    } else {
      setVisible(false);
    }
  
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);
  

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.65)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: visible ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out',
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        style={{
          transform: visible ? 'translateY(0)' : 'translateY(100%)',
          transition: 'transform 0.5s cubic-bezier(0.16, 1, 0.3, 1)',
          backgroundColor: '#fff',
          borderRadius: '20px',
          padding: '85px 55px',
          maxWidth: '540px', // Increased width
          width: '95%',
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Decorative element - top ribbon */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '8px',
            background: `linear-gradient(90deg, ${primaryColor}, black)`,
          }}
        />
        
        {/* Close button */}
        <div
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '15px',
            right: '15px',
            width: '35px',
            height: '35px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
            backgroundColor: '#f8f8f8',
          }}
        >
          <span
            style={{
              fontSize: '36px',
              lineHeight: 1,
              color: '#666',
              fontWeight: 'bold',
            }}
          >
            ×
          </span>
        </div>

        {/* Gem icon */}
        <div
          style={{
            width: '110px',
            height: '110px',
            margin: '0 auto 20px',
            backgroundColor: '#f5f0ff',
            // overflow:'hidden',
            // borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
           <img style={{width:'100%',height:'100%',borderRadius:'.4rem'}} src="/images/gemx.png" alt="" />

        </div>

        <h2
          style={{
            fontSize: '26px',
            marginTop:'3rem',
            marginBottom: '16px',
            color: '#333',
            fontWeight: '700',
          }}
        >
          Upgrade to Gem X
        </h2>
        
        <p
          style={{
            fontSize: '17px',
            color: '#555',
            marginBottom: '30px',
            lineHeight: '1.6',
          }}
        >
          Unlock your full potential with a <strong style={{ color: primaryColor }}>Gem X membership</strong>. Access your referral link, grow your team, and start earning Bonus today.
        </p>
        
        {/* Features list */}
        <div style={{ marginBottom: '30px', textAlign: 'left' }}>
          {['Personal referral link', 'Earn Bonus', 'Priority support'].map((feature, index) => (
            <div
              key={index}
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '12px',
                fontSize: '16px',
                color: '#444',
              }}
            >
              <div
                style={{
                  width: '20px',
                  height: '20px',
                  borderRadius: '50%',
                  backgroundColor: '#e0e0e0',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '12px',
                  flexShrink: 0,
                }}
              >
                <span style={{ color: primaryColor, fontSize: '14px' }}>✓</span>
              </div>
              {feature}
            </div>
          ))}
        </div>

        <button
          onClick={() => navigate("/renew")}
          style={{
            backgroundColor: primaryColor,
            color: '#fff',
            padding: '14px 28px',
            fontSize: '17px',
            border: 'none',
            borderRadius: '12px',
            cursor: 'pointer',
            transition: 'all 0.3s',
            fontWeight: '600',
            // boxShadow: `0 6px 12px rgba(149, 76, 234, 0.25)`,
            width: '100%',
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = 'black';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = primaryColor;
            e.target.style.transform = 'translateY(0)';
          }}
        >
          Upgrade Now
        </button>
        
      </div>
    </div>
  );
};

export default GemxInfo;